import PostTableFilter from './post-table-filter';

export default PostTableFilter;